import { render } from "./InventoryStockOutView.vue?vue&type=template&id=0485f137"
import script from "./InventoryStockOutView.vue?vue&type=script&lang=js"
export * from "./InventoryStockOutView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__